// extracted by mini-css-extract-plugin
module.exports = {"section":"Rooms_section__3EeSe","alert":"Rooms_alert__1KbqA","texts":"Rooms_texts__2_olt","btns":"Rooms_btns__35hiJ","stickyFooter":"Rooms_stickyFooter__1k0fn"};